import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FutureFacingInvestment from "./sections/FutureFacingInvestment";
import CertifiedLocal from "./sections/CertifiedLocal";
import ArchitectingChange from "./sections/ArchitectingChange";
import TheGrowthBlueprint from "./sections/TheGrowthBlueprint";
import ArtistsEcho from "./sections/ArtistsEcho";
import SecureYourWorkplaceToday from "./sections/SecureYourWorkplaceToday";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FutureFacingInvestment />
      <CertifiedLocal />
      <ArchitectingChange />
      <TheGrowthBlueprint />
      <ArtistsEcho />
      <SecureYourWorkplaceToday />
      <Footer />
    </div>;
}